import {initTrackableWidgets} from './init';
import {BrandhubBackground} from './brandhub_background';
import {Stage} from './stage';
import {CliplisterVideo} from './cliplister-video';
import {otto} from '@otto-ec/global-resources/nexus';
import {LotteryGame} from './lottery_game';
import {PictureTextSlider} from './picture_text_slider';
import PictureTextGrid from "./picture-text-widgets/picture_text_grid";

if (!otto.ft3.promo.staticcontent.isReady) {
    otto.ft3.promo.staticcontent.assignNamespace({
        brandhub_background: {
            init: () => {
                new BrandhubBackground();
            },
        },
        stage: {
            init: () => {
                new Stage();
            },
        },
        link: {
            init: () => {
                initTrackableWidgets();
            },
        },
        picture_info_card: {
            init: () => {
                initTrackableWidgets();
            },
        },
        video: {
            init: () => {
                initTrackableWidgets();
                new CliplisterVideo();
            },
        },
        lottery_game: {
            init: () => {
                const lotteryGame = new LotteryGame();
                lotteryGame.init();
            },
        },
        picture_text_slider: {
            init: () => {
                new PictureTextSlider();
            },
        },
        picture_text_grid: {
            init: () => {
                const containers = document.getElementsByClassName('promo_staticcontent--picture-text-grid-widget');
                [].forEach.call(containers, (container) => {
                    if (container.getAttribute('data-tracked') !== 'true') {
                        new PictureTextGrid(container);
                    }
                });
            },
        },
    });
}
